async function resetPassword() {
  return null
}

export default {
  resetPassword,
}
